import { validate } from "../../helpers/validate.js";
import { attributesMathSchema } from "./attributes.js";
import { guideMathHtml } from "../../elements/math/components.js";
import { withDataAttrFallback } from "../../helpers/attributes-with-data-fallback.js";
const scalarMath = {
  name: "scalar-math",
  tagName: "scalar-math",
  tiptapName: "math",
  attributeTransform: (_content, _attributes) => {
    const attributes = withDataAttrFallback(_attributes);
    return validate(attributesMathSchema, {
      equation: attributes.equation ? attributes.equation.toString() : attributes.dataContent ? attributes.dataContent.toString() : "",
      caption: attributes.caption ? attributes.caption.toString() : ""
    });
  },
  render: async (props) => guideMathHtml(props)
};
import { ScalarMathVue } from "./components.js";
export {
  ScalarMathVue,
  scalarMath
};
//# sourceMappingURL=index.js.map
